import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { WhyChooseSecWrapper } from "../../styles/StyledComponents/WhyChooseSecWrapper";
import assests from "../../ui/assests";
import CommonButton from "../../ui/CommonButton/CommonButton";
import { whyChooseList } from "../../ui/json/demo.mock";

const WhyChooseSec = () => {
  const settings: Settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 3000,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: false,
    arrows: false,
    swipeToSlide: false,
    focusOnSelect: true,
    centerMode: false,
    lazyLoad: "ondemand",
  };

  // useEffect(() => {
  //   first

  //   return () => {
  //     second
  //   }
  // }, [third])

  return (
    <WhyChooseSecWrapper className="cmn_gap">
      <div className="container">
        <div className="whyChoose_row row">
          <div className="whyChoose_col whyChhoseLeft">
            <h2>
              Why Choose <span>Us ?</span>
            </h2>
            <p className="trusted_partner_text">
              Your Trusted Partner for Fast, Agile, and Scalable Digital
              Transformation.
            </p>
            <p>
              At EMIIT, we specialize in web design, development, and digital
              marketing. We deliver high-quality, result-driven solutions to
              help your business thrive.
            </p>
            <figure className="choose_figure">
              <img src={assests.bigLogo} alt="logo" />
            </figure>
            <CommonButton
              className="know_more_btn"
              variant="contained"
              color="primary"
              fullWidth
            >
              Know More
            </CommonButton>
          </div>
          <div className="whyChoose_col whyChhoseRht">
            <Slider {...settings}>
              {whyChooseList?.map((data, index) => (
                <div key={index} className="whyChoose_List">
                  <i>{index + 1}</i> <span>{data}</span>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </WhyChooseSecWrapper>
  );
};

export default WhyChooseSec;
